/**
 * Entering, leaving or losing a view-as session restarts the app with a full-document navigation, so no component
 * keeps state built from the other identity's data. Kept in its own module so tests can replace the navigation.
 */
const HOME_PATH = '/';

export function navigateHome (): void {
  window.location.assign(HOME_PATH);
}
